module.exports = __webpack_public_path__ + "static/media/icon_44.4a624f07.svg";